export const CardImg = {
    height: '32px',
    width: '32px',
    objectFit: 'cover',
    borderRadius: '50%',
}

export const ButtonStyle = {
    height: "32px",
    alignSelf: 'flex-start',
}
